'use client'
import {
  context_default
} from "./chunk-4VWYIUCY.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-IJKZ5OMO.mjs";

// src/core/context/root/provider.tsx
import { useState } from "react";
import { jsx } from "react/jsx-runtime";
var WbkTicketingProvider = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  var _a2, _b2, _c, _d, _e;
  const [state] = useState(props);
  const value = __spreadProps(__spreadValues({}, state), {
    seats: {
      workspace: {
        seatIO: (_a2 = props.seats.workspace) == null ? void 0 : _a2.seatIO,
        seatCloud: (_b2 = props.seats.workspace) == null ? void 0 : _b2.seatCloud
      },
      colorScheme: props.seats.colorScheme ? props.seats.colorScheme : "dark"
    },
    resell: {
      domain: ((_c = props.resell) == null ? void 0 : _c.domain) || "https://resell.webook.com",
      // Core stays translation-free: pass through the app's copy if any, else leave it to the UI.
      terms: (_d = props.resell) == null ? void 0 : _d.terms
    },
    header: (_e = props.header) != null ? _e : true
  });
  return /* @__PURE__ */ jsx(context_default.Provider, { value, children });
};

export {
  WbkTicketingProvider
};
//# sourceMappingURL=chunk-ME4SZ6MX.mjs.map